<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：项目管理-项目编辑-基础信息
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--基本信息-->
    <div class="common-form">基本信息</div>
    <el-form-item label="项目名称：" :rules="[{ required: true, message: '请填写项目名称' }]" prop="model.productName">
      <el-input v-model="form.model.productName" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="项目分类：" :rules="[{ required: true, message: '请选择项目分类' }]" prop="model.categoryId">
      <el-select v-model="form.model.categoryId">
        <el-option v-for="(item, index) in form.category" :key="index" :label="item.name"
          :value="item.categoryId"></el-option>
      </el-select>
    </el-form-item>
    
    <el-form-item label="项目封面：" :rules="[{ required: true, message: '请上传项目封面' }]" prop="model.image">
      <div class="draggable-list">

        <div class="item img-select" @click="openProductUpload('image', 'poster')" v-if="form.model.imageId == 0">
          <i class="el-icon-plus"></i>
        </div>
        <div v-if="form.model.imageId != 0" class="item" @click="openProductUpload('image', 'poster')">
          <img :src="form.model.image[0].filePath" width="100" height="100" />
        </div>
      </div>
      <div style="color:orange">注意：上传的尺寸比例为3:4最优</div>
    </el-form-item>
    <el-form-item label="项目图片：" :rules="[{ type: 'array', required: true, min: 1, message: '请上传项目图片', trigger: 'change' }]" prop="model.detailimg">
      <el-row>
        <div class="draggable-list">
          <!-- <div class="item img-select" v-if="form.model.poster_id==0" @click="openProductUpload('image', 'poster')"><i class="el-icon-plus"></i></div>
          <div v-if="form.model.poster_id!=0" class="item" @click="openProductUpload('image', 'poster')">
            <img :src="form.model.poster.filePath" width="100" height="100" />
          </div> -->
        </div>
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.model.detailimg">
            <transition-group>
              <div class="item" v-for="(item, index) in form.model.detailimg" :key="item.filePath">
                <img v-img-url="item.filePath" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)">
                  <i class="el-icon-close"></i>
                </a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('image', 'image')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div style="color:orange">注意：上传的尺寸比例为3:4最优</div>
      </el-row>

    </el-form-item>
    <el-form-item label="服务类型：">
      <el-select size="small" v-model="form.model.serviceId" placeholder="服务类型" class="max-w460" style="width:100%">
        <el-option v-for="(item, index) in form.serviceList" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="项目类型：">
      <el-select size="small" class="max-w460" style="width:100%" v-model="form.model.serviceCategory"
        placeholder="项目类型">
        <el-option v-for="(item, index) in form.serviceCategory" :key="index" :label="item.value"
          :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="商户类型">
      <el-select size="small" v-model="form.model.shopSupplierId" placeholder="商户类型" class="max-w460" style="width:100%">
        <el-option v-for="(item, index) in form.supplierList" :key="index" :label="item.name" :value="item.shopSupplierId"></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item label="服务时间(分钟)：">
      <el-input v-model="form.model.serviceTime" class="max-w460" type="number" ></el-input>
    </el-form-item>

    <!-- <el-form-item label="是否加钟">
      <el-radio-group v-model="form.model.isClock">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <el-form-item label="项目价格：" width="80" :rules="[{ required: true, message: '请填写项目价格' }]"
      prop="model.sku.productPrice">
      <el-input type="number" v-model="form.model.sku.productPrice" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="虚拟销量：" width="80"
      prop="model.salesInitial">
      <el-input type="number" v-model="form.model.salesInitial" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="项目排序：" :rules="[{ required: true, message: ' ' }]" prop="model.productSort">
      <el-input type="number" min="0" v-model="form.model.productSort" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="简介：" prop="intro">
      <el-input v-model="form.model.intro" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="项目标签：" prop="intro">
      <el-input v-model="form.model.tag" class="max-w460"></el-input>
    </el-form-item>
    <!-- <el-form-item label="项目标签：" prop="model.tag">
      <el-tag :key="tagItem" v-for="tagItem in form.model.tag" closable :disable-transitions="false"
        @close="handleClose(tagItem)">
        {{ tagItem }}
      </el-tag>
      <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
        @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
      </el-input>
      <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
    </el-form-item> -->
    <!--项目图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</template>

<script>
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isProductUpload: false,
      config: {},
      file_name: "image",
      inputVisible: false,
      inputValue: ""
    };
  },
  inject: ["form"],
  created() {
    console.log("===========form", this.form);
  },
  methods: {
    /*打开上传图片*/
    openProductUpload: function (fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 9,
          fileType: "image"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },

    /*上传项目图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "video") {
          this.form.model.video_id = e[0].fileId;
          this.form.model.video = e[0];
        } else if (this.file_name == "image") {
          let imgs = this.form.model.detailimg.concat(e);
          this.$set(this.form.model, "detailimg", imgs);
          console.log(imgs);
        } else if (this.file_name == "poster") {
          this.form.model.imageId = e[0].fileId;
          this.form.model.image = e;
        }
      }
      this.isProductUpload = false;
    },

    /*删除项目图片*/
    deleteImg(index) {
      this.form.model.detailimg.splice(index, 1);
    },
    delVideo() {
      this.form.model.video_id = 0;
      this.form.model.video = {};
    },
    handleClose(tagItem) {
      this.form.model.tag.splice(this.form.model.tag.indexOf(tagItem), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        if (this.form.model.tag == null) {
          this.form.model.tag = [];
        }
        this.form.model.tag.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper>span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Basic.vue